import Delete from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ConfirmationModal from '~/components/ConfirmationModal';
import { useDeleteRoute } from '~/hooks/api/useDeleteRoute';
import messages from './messages';
import { useNavigate } from '@tanstack/react-router';
import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';

type DeleteRouteButtonProps = {
  routeId: number;
};

const DeleteRouteButton = (props: DeleteRouteButtonProps) => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();
  const routeDeleteMutation = useDeleteRoute(props.routeId, {
    onSuccess: () => {
      showSnackbar({
        message: intl.formatMessage(messages.deleteSuccess),
      });
      navigate({ to: '/trolley-routes' });
    },
    onError: () => {
      showSnackbar({
        message: intl.formatMessage(messages.deleteFailure),
      });
    },
  });
  const handleDelete = () => {
    routeDeleteMutation.mutate();
  };
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const toggleDeleteModal = () => {
    setDeleteModalOpen(!deleteModalOpen);
  };
  return (
    <>
      <Tooltip title={<FormattedMessage {...messages.deleteButton} />}>
        <IconButton
          edge="end"
          color="inherit"
          aria-label="delete"
          onClick={toggleDeleteModal}
          size="large"
        >
          <Delete />
        </IconButton>
      </Tooltip>
      <ConfirmationModal
        open={deleteModalOpen}
        title={intl.formatMessage(messages.deleteConfirmTitle)}
        text={<FormattedMessage {...messages.deleteConfirmText} />}
        confirmLabel={<FormattedMessage {...messages.deleteConfirmDelete} />}
        cancelLabel={<FormattedMessage {...messages.deleteConfirmCancel} />}
        onCancel={toggleDeleteModal}
        onConfirm={handleDelete}
      />
    </>
  );
};

export default DeleteRouteButton;
